module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE2IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04LjcyMDU4IDguMjUxMTVDOC4zMjcxOCA4LjY1OTk5IDcuNjcyODIgOC42NTk5OSA3LjI3OTQyIDguMjUxMTVMMC45NjkxOTcgMS42OTMzOEMwLjM1Nzg3NyAxLjA1ODA3IDAuODA4MTE0IDQuMDQzODZlLTA3IDEuNjg5NzcgNC44MTQ2M2UtMDdMMTQuMzEwMiAxLjU4NDc4ZS0wNkMxNS4xOTE5IDEuNjYxODZlLTA2IDE1LjY0MjEgMS4wNTgwNyAxNS4wMzA4IDEuNjkzMzhMOC43MjA1OCA4LjI1MTE1WiIgZmlsbD0iIzU2MzQwQyIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/triangle.svg
// module id = SnNW
// module chunks = 0